module.exports = __webpack_public_path__ + "static/media/Boulder_Badge.cdbba6c8.png";